module.exports = __webpack_public_path__ + "img/envelope.57ab8068.svg";